export interface MissionTitlePart {
  text: string;
  highlighted: boolean;
}

// Match complete displayed values after {{CUR}} has been replaced with $ or C$.
const TITLE_VALUE_PATTERN = /(?<![\w.,])(?:C\$\s*|\$)\d+(?:,\d{3})*(?:\.\d+)?|\b\d+(?:,\d{3})*(?:\.\d+)?(?: SC| bets?)\b/g;

export function getMissionTitleParts(title: string): MissionTitlePart[] {
  const parts: MissionTitlePart[] = [];
  let cursor = 0;

  for (const match of title.matchAll(TITLE_VALUE_PATTERN)) {
    const start = match.index;

    if (start > cursor) {
      parts.push({ text: title.slice(cursor, start), highlighted: false });
    }

    parts.push({ text: match[0], highlighted: true });
    cursor = start + match[0].length;
  }

  if (cursor < title.length || parts.length === 0) {
    parts.push({ text: title.slice(cursor), highlighted: false });
  }

  return parts;
}
